import React from 'react'
import styles from './table-skeleton.module.scss'

// Lebar bar bervariasi supaya baris terasa natural (deterministik, bukan acak).
const WIDTHS = [72, 88, 56, 64, 78, 50, 82, 60, 68, 90]

/**
 * Skeleton tabel yang "sadar kolom": placeholder mengikuti jumlah, lebar, dan
 * rata (align) kolom asli, dengan satu sapuan shimmer melintasi seluruh bodi.
 * Dipakai shared Table saat load pertama (belum ada data).
 */
const TableSkeleton = ({ columns = [], rows = 8, isMobileView = false }) => {
  if (isMobileView) {
    return (
      <div className={styles.skeleton}>
        <div className={styles.body}>
          {Array.from({ length: 4 }).map((_, r) => (
            // eslint-disable-next-line react/no-array-index-key
            <div className={styles.card} key={`card-${r}`}>
              <span className={`${styles.bar} ${styles.w40}`} />
              <span className={`${styles.bar} ${styles.w80}`} />
              <span className={`${styles.bar} ${styles.w60}`} />
            </div>
          ))}
        </div>
      </div>
    )
  }

  const cols = columns.length ? columns : Array.from({ length: 5 })

  return (
    <div className={styles.skeleton}>
      <div className={styles.body}>
        {Array.from({ length: rows }).map((_, r) => (
          // eslint-disable-next-line react/no-array-index-key
          <div className={styles.row} key={`row-${r}`}>
            {cols.map((col, c) => {
              const isRight = col?.align === 'right'
              const width = WIDTHS[(r * 2 + c * 3) % WIDTHS.length]
              const flex = col?.width
                ? `0 0 ${typeof col.width === 'number' ? `${col.width}px` : col.width}`
                : '1 1 0'
              return (
                <div
                  // eslint-disable-next-line react/no-array-index-key
                  key={`cell-${c}`}
                  className={styles.cell}
                  style={{ flex, justifyContent: isRight ? 'flex-end' : 'flex-start' }}
                >
                  <span
                    className={`${styles.bar}${isRight ? ` ${styles.strong}` : ''}`}
                    style={{ width: `${width}%` }}
                  />
                </div>
              )
            })}
          </div>
        ))}
      </div>
    </div>
  )
}

export default TableSkeleton
